// Error messages for login, membership, password, common, etc.
// Format: { [key: string]: { en: string, ja: string } }

const errorMessages = {
  LOGIN_INVALID: {
    en: 'Your email address or password is incorrect',
    ja: 'メールアドレスまたはパスワードが正しくありません。',
  },
  LOGIN_EMAIL_REQUIRED: {
    en: 'Email is required',
    ja: 'メールアドレスを入力してください。',
  },
  LOGIN_EMAIL_FORMAT: {
    en: 'The format email is incorrect',
    ja: 'メールアドレスの形式が間違っています。',
  },
  LOGIN_EMAIL_INCORRECT: {
    en: 'The email is incorrect',
    ja: 'メールアドレスが間違っています。',
  },
  LOGIN_EMAIL_NOT_EXIST: {
    en: 'Email does not exist',
    ja: 'メールアドレスが存在しません。',
  },
  LOGIN_PASSWORD_REQUIRED: {
    en: 'Password is required',
    ja: 'パスワードを入力してください。',
  },
  LOGIN_PASSWORD_OR_EMAIL_WRONG: {
    en: 'The password or email is wrong',
    ja: 'パスワードまたはメールアドレスが無効です。',
  },
  /*LOGIN_PASSWORD_EXPIRED: {
    en: 'The password is expired',
    ja: 'パスワードの有効期限が切れています。',
  },
  LOGIN_USER_INACTIVE: {
    en: 'The user is inactive',
    ja: 'アカウントが無効です。管理者へお問い合わせください。',
  },*/
  
  // Forgot Password Messages
  FORGOT_EMAIL_REQUIRED: {
    en: 'Email is required',
    ja: 'メールアドレスを入力してください。',
  },
  FORGOT_EMAIL_FORMAT: {
    en: 'The format email is incorrect',
    ja: 'メールアドレスの形式が間違っています。',
  },
  FORGOT_EMAIL_NOT_EXIST: {
    en: 'Email does not exist',
    ja: 'メールアドレスが存在しません。',
  },
  
  // Reset Password Messages
  RESET_PASSWORD_REQUIRED: {
    en: 'Password is required',
    ja: 'パスワードを入力してください。',
  },
  RESET_PASSWORD_CONFIRM_REQUIRED: {
    en: 'Password confirmation is required',
    ja: 'パスワード確認を入力してください。',
  },
  RESET_PASSWORD_NOT_MATCH: {
    en: 'The password does not match',
    ja: 'パスワードが一致しません。',
  },
  RESET_PASSWORD_FORMAT: {
    en: 'The password must contain at least one uppercase letter, one lowercase letter, one number, and one special character.',
    ja: 'パスワードには「半角英数字(大文字・小文字・数字)」「半角記号（!"#$%&\'()*+,-.\/|:;<=>?@[]^_`{}~）」を含む8～32字で設定してください。',
  },
  RESET_PASSWORD_LENGTH: {
    en: 'Please enter a password between 8 and 32 characters.',
    ja: 'パスワードは8文字以上32文字以内で設定してください。',
  },
  LOGIN_EMAIL_TOO_LONG: {
    en: 'Enter >255 characters in email field',
    ja: 'メールアドレス/パスワードは半角255文字以内で入力してください。',
  },
  LOGIN_PASSWORD_TOO_LONG: {
    en: 'Enter >255 characters in the password field',
    ja: 'パスワードは半角255文字以内で入力してください。',
  },
  // ...add more as needed
};

export default errorMessages;
